// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
export const resources = {
  en: {
    translation: {
      loginHeader: "Login",
      signIn: {
        header:
          "To access your GoSimpleTax account, please provide the information below.",
        label: {
          username: "Email",
          password: "Your GoSimpletax password",
          signin: "Sign In",
          forgot_password: "Forgot password?",
          register_message: "Not yet registered? Sign up here.",
          failed_message:
            "* Please enter a correct username or email and password. Note that both fields are case-sensitive. Looking for SimpleTax Canada click here",
        },
        placeholder: {
          username: "Email",
          password: "Password",
        },
        response: {
          success_message: "SignIn success",
          error_message: "SignIn failed",
        },
      },
      signup: {
        which: {
          signup_header: "Register with GoSimpleTax",
          login_header: "Log into your account",
          access: "Access previously saved information",
          message:
            "As a Which? Member you can complete your tax return and file directly to HMRC for just £34.99. Non members pricing is £69.99.",
          button: "Register",
          advantages: {
            1: "Easy to use and jargon-free",
            2: "Safe and secure - protected by 256-bit encryption",
            3: "Officially recognised by HMRC",
            4: "Tips that could save you money on allowances and expenses you might have missed",
          },
          supported_income_types: {
            header: "Supported income types",
            types: {
              1: "Employment - SA102 Full/Short",
              2: "Self-employment - SA103 Full/Short",
              3: "Interests and dividends - SA100",
              4: "Property - SA105",
              5: "Income from pensions - SA100",
              6: "Ministers of Religion - SA102M",
              7: "Partnership - SA104 Full/Short",
              8: "Residency - SA109",
              9: "Foreign - SA106",
              10: "Trust - SA107",
              11: "Capital Gains - SA108",
            },
          },
          footer: {
            advantages: {
              1: "100% online, recognised by HMRC",
              2: "Easy to understand forms",
              3: "Stay on top of your tax money",
              4: "Nothing to install, runs everywhere",
            },
          },
        },
        header: "Try for free",
        sub_header: "- no credit card required! ",
        sub_header_right: "Start your free trial ",
        footer: " ",
        hints: {
          1: "100,000+ tax returns submitted",
          2: "Recognised by HMRC",
          3: "UK based support",
          4: "Bank level security",
        },
        placeholder: {
          username: "Username",
          firstname: "First name",
          surname: "Last name",
          email: "Email",
          create_password: "Create Password",
          phone_number: "Phone Number",
          business_name: "Business Name",
        },
        terms: {
          message: "By clicking the Get Started button, you agree to our ",
          link: "terms of service.",
        },
        button: "GET STARTED",
        password_validation:
          "Password requirements: minimum 8 characters, 1 UPPER case character and 1 Special character (@ % # etc)",
        email_consent: {
          label: "I consent to receiving emails from GoSimpleTax",
        },
        existing_user: {
          message: "Already registered?",
          signin: "Sign in",
        },
        response: {
          success_message: "SignUp success",
          error_message: "SignUp failed",
        },
      },
      forgotpassword: {
        header:
          "In order to reset your SimpleTax password, please provide us with the email address you used to create an account, in the form below.",
        placeholder: {
          email: "Email",
        },
        button: "Reset Password",
        footer: "Back to SIGNIN",
        response: {
          success_message:
            "Password Update link has been sent successfully to your email!",
          error_message: "Password Update Failed",
        },
      },
      profile: {
        header: {
          profile: "MY PROFILE",
          password: "MY PASSWORD",
        },
        password: {
          old_password: {
            label:
              "To update your password, Please enter your existing password",
            placeholder: "Existing password",
          },
          new_password: "New Password",
          confirm_password: "Confirm Password",
        },
        button: "SAVE",
        cancel_account: {
          button: "CANCEL MY ACCOUNT",
          title: "PLEASE READ CAREFULLY",
          description: {
            0: "By cancelling this account you will cease to have access to GoSimpleTax, including your tax returns. If at anytime in the future you require your account re-activation, please email help@gosimpletax.com",
            1: "The account and your data will NOT be deleted. If you do require your data deletion, please email help@gosimpletax.com to make such a request",
            2: "Please click CANCEL ACCOUNT if you wish to continue",
          },
        },
        footer: "Go to my preferences",
        placeholder: {
          password: "Password",
          firstname: "First Name",
          email: "Email",
          lastname: "Last Name",
          mobile: "Mobile",
        },
        response: {
          success_message: "Profile has been updated successfully",
          error_message: "Profile Update Failed",
        },
      },
      preferences: {
        header: "AGENT PREFERENCES",
        button: "SAVE",
        field: {
          1: "I am an accountant/tax agent and wish to file tax returns on behalf of my clients",
          2: "I wish to file tax returns on behalf of close family and friends and I am not accountant or tax advisor",
        },
        emailnotification: {
          label: "Email Notification",
          field:
            "I would like to recieve newsletters and other relevant information from @GoSimpleTax Ltd",
        },
        dataAccess: {
          label: "Data Access",
          field:
            "I would like to like the GoSimpleTax support team to have access to my data",
        },
        practiceName: "Practice Name",
        agentId: "Agent ID",
        hmrcUserName: "HMRC User Name",
        footer: "Back to my profile",
        response: {
          success_message: "Agent Details updated successfully",
          error_message: "Agent Details update failed",
        },
      },
      activationCode: {
        title: "Almost There",
        linkTitle: "Resend activation code?",
        activatedText:
          "Your email address is successfully verified. Click Signin to proceed further.",
        sentHeader: "Please verify your email",
        activationHeader: "Email Verified",
        sentFooter:
          "If you don't see it, you may need to check your spam folder. Still can't find the email? No problem. Click Resend Verification Email",
        sentText:
          "You're almost there! We sent an email, Just click on the link in that email to complete your signup.",
        header:
          "In order to resend your SimpleTax email activation code, please provide us with the email address you used to create an account, in the form below.",
        placeholder: {
          email: "Email",
        },
        button: "Resend Activation Code",
        footer: "Back to SIGNIN",
        response: {
          success_message: "Resend activation code successful",
          error_message: "Resend activation code failed",
        },
      },
    },
  },
};

export default resources;
